export const ADMIN_PLATFORM_SETTINGS_CONSTANTS = Object.freeze({
  SETTINGS_ID: "general",
});
